import { Component, OnInit } from "@angular/core";
import { ViewAndUpdateConfig } from "./viewAndUpdateConfig.service";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-view-and-update-config",
  templateUrl: "./view-and-update-config.component.html",
  styleUrls: ["./view-and-update-config.component.sass"],
})
export class ViewAndUpdateConfigComponent implements OnInit {
  // Package Config
  allAmounts: any;
  id: any;
  helperAmount: any;
  couponAmount: any;
  tripFareGST: any;
  helperGST: any;
  commission: any;
  commissionGST: any;
  convenience: any;
  convenienceGST: any;
  distanceForTripNotification: any;
  helperTDSPercent: Number;
  driverTDSPercent: Number;
  minimumDistanceForTrip: any;
  closeResult: string;
  viewPackageConfig: boolean = false;
  viewApplicationConfig: boolean = false;
  viewQrConfig: boolean = false;

  constructor(
    private modalService: NgbModal,
    private viewAndUpdateConfig: ViewAndUpdateConfig,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getPkgConfig();
  }
  getPkgConfig() {
    this.viewAndUpdateConfig.getPackageConfig().subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("getPackageConfig", result);
        this.allAmounts = result.data;
        this.id = this.allAmounts._id;
        this.helperAmount = this.allAmounts.helpersBasicAmount;
        this.couponAmount = this.allAmounts.couponBasicAmount;
        this.tripFareGST = this.allAmounts.tripFareGST;
        this.helperGST = this.allAmounts.helperGST;
        this.commission = this.allAmounts.commissionFee;
        this.commissionGST = this.allAmounts.commissionFeeGST;
        this.convenience = this.allAmounts.convenienceFee;
        this.convenienceGST = this.allAmounts.convenienceFeeGST;
        this.distanceForTripNotification =
          this.allAmounts.distanceForNotification;
        this.helperTDSPercent = this.allAmounts.helperTDS;
        this.driverTDSPercent = this.allAmounts.driverTDS;
        this.minimumDistanceForTrip = this.allAmounts.minimumDistanceForTrip;
        this.viewPackageConfig = true;
        this.viewPackerMoverConfig = false;
        this.viewApplicationConfig = false;
        this.viewQrConfig = false;
        this.viewRange = false;
        this.viewCoupan = false;
        console.log(this.id);
      }
    });
  }

  updatePackageConfig() {
    let data = {
      id: this.id,
      helpersBasicAmount: this.helperAmount,
      couponBasicAmount: this.couponAmount,
      tripFareGST: this.tripFareGST,
      helperGST: this.helperGST,
      commissionFee: this.commission,
      commissionFeeGST: this.commissionGST,
      convenienceFee: this.convenience,
      distanceForNotification: this.distanceForTripNotification,
      convenienceFeeGST: this.convenienceGST,
      minimumDistanceForTrip: this.minimumDistanceForTrip,
      helperTDS: this.helperTDSPercent,
      driverTDS: this.driverTDSPercent,
    };
    console.log("reqData", data);
    this.spinner.show();
    this.viewAndUpdateConfig
      .packageConfigUpdate(data)
      .subscribe((result: any) => {
        console.log("updatePackageConfigData", result);
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.toastr.success(result.message);
          this.getPkgConfig();
          this.modalService.dismissAll();
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }
  editPackageConfig(editPkgConfig) {
    this.openModal(editPkgConfig);
    this.helperAmount = this.helperAmount;
    this.couponAmount = this.couponAmount;
    this.tripFareGST = this.tripFareGST;
    this.helperGST = this.helperGST;
    this.commission = this.commission;
    this.commissionGST = this.commissionGST;
    this.convenience = this.convenience;
    this.convenienceGST = this.convenienceGST;
    this.distanceForTripNotification = this.distanceForTripNotification;
    this.helperTDSPercent = this.helperTDSPercent;
    this.minimumDistanceForTrip = this.minimumDistanceForTrip;
  }

  allRanges: any[] = [];
  viewRange: boolean = false;
  getAllRange() {
    this.spinner.show();
    this.viewAndUpdateConfig.getRange().subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("All Range", result.data);
        this.allRanges = result.data;
        this.viewRange = true;
        this.viewPackageConfig = false;
        this.viewPackerMoverConfig = false;
        this.viewApplicationConfig = false;
        this.viewQrConfig = false;
        this.viewCoupan = false;
        this.spinner.hide();
      } else this.toastr.error(result.message), this.spinner.hide();
    });
  }

  minimumDistance: Number;
  maximumDistance: Number;
  range: any;
  rangeId: "";
  editRange(editData, data) {
    // console.log(data);
    this.minimumDistance = data.min;
    this.maximumDistance = data.max;
    this.range = data.name;
    this.rangeId = data._id;
    this.openModal(editData); // Open the modal to edit the range
  }

  updateRange() {
    this.spinner.show();
    let data = {
      id: this.rangeId,
      min: this.minimumDistance,
      max: this.maximumDistance,
      name: this.range,
    };
    this.viewAndUpdateConfig.updateRange(data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        console.log("range update", result.data);
        this.toastr.success(result.message);
        this.modalService.dismissAll();
        this.getAllRange();
      } else this.toastr.error(result.message);
    });
  }

  // coupan view and update
  coupanData: any;
  viewCoupan: boolean = false;
  getCoupanConfig() {
    this.spinner.show();
    this.viewAndUpdateConfig.getCupan().subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        console.log("Coupan Data", result.data);
        // this.coupanData=result.data
        this.coupanData = result.data.map((item) => ({
          ...item,
          createdOn: new Date(item.createdOn).getTime(), // Convert the string to a valid Date
          updatedOn: new Date(item.updatedOn).getTime(),
        }));
        // console.log("Coupan Data", this.coupanData)
        this.viewCoupan = true;
        this.viewPackerMoverConfig = false;
        this.viewPackageConfig = false;
        this.viewApplicationConfig = false;
        this.viewQrConfig = false;
        this.viewRange = false;
      } else this.toastr.error(result.message);
    });
  }
  coupanDataAmt: any;
  coupanDataCoupanCode: any;
  coupanDataExpiry: any;
  coupanId: any;
  coupanDataIsActive: Number;
  coupanDataIsDeleted: Number;
  editCoupan(editCoupanData, data) {
    // console.log(data);
    this.coupanDataAmt = data.amount;
    this.coupanDataCoupanCode = data.code;
    this.coupanDataExpiry = data.expiry;
    this.coupanDataIsActive = data.isActive;
    this.coupanDataIsDeleted = data.isDeleted;
    this.coupanId = data._id;
    this.openModal(editCoupanData);
  }
  updateCoupan() {
    this.spinner.show();
    let data = {
      id: this.coupanId,
      code: this.coupanDataCoupanCode,
      amount: this.coupanDataAmt,
      expiry: this.coupanDataExpiry,
      isActive: this.coupanDataIsActive,
      isDeleted: this.coupanDataIsDeleted,
    };
    this.viewAndUpdateConfig.updateCoupan(data).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.toastr.success(result.message);
        this.getCoupanConfig();
        this.modalService.dismissAll();
      } else this.toastr.error(result.message);
    });
  }
  coupanActivationStatus: Number;
  updateCoupanActivationStatus(event, data) {
    let sendData = {
      id: data._id,
      isActive: event == true ? 1 : 0,
      code: data.code,
      amount: data.amount,
      expiry: data.expiry,
      isDeleted: data.isDeleted,
    };
    // console.log(sendData);
    this.spinner.show();
    this.viewAndUpdateConfig.updateCoupan(sendData).subscribe((result: any) => {
      this.spinner.hide();
      if (result.statusCode == 200) {
        this.toastr.success(result.message);
      } else this.toastr.error(result.message);
    });
  }

  // Packers & Movers Configuration
  viewPackerMoverConfig: boolean = false;
  packersMoversLitePrice: any;
  packersMoversLiteStandard: any;
  packersMoversLitePremium: any;
  packersMoverID: any;
  getPackerMoverConfig() {
    this.viewAndUpdateConfig.getPackerMoverConfig().subscribe((result: any) => {
      if (result.statusCode == 200) {
        console.log("getPackerMoverConfig", result);
        this.packersMoversLitePrice = result.data.packersMoversLitePrice;
        this.packersMoversLiteStandard = result.data.packersMoversLiteStandard;
        this.packersMoversLitePremium = result.data.packersMoversLitePremium;
        this.packersMoverID = result.data._id;
        this.viewPackerMoverConfig = true;
        this.viewPackageConfig = false;
        this.viewApplicationConfig = false;
        this.viewQrConfig = false;
        this.viewRange = false;
        this.viewCoupan = false;
        // console.log(this.id)
      }
    });
  }

  updatePackerMoverConfig() {
    let data = {
      id: this.packersMoverID,
      packersMoversLitePrice: this.packersMoversLitePrice,
      packersMoversLiteStandard: this.packersMoversLiteStandard,
      packersMoversLitePremium: this.packersMoversLitePremium,
    };
    // console.log("reqData",data)
    this.spinner.show();
    this.viewAndUpdateConfig
      .packerMovereConfigUpdate(data)
      .subscribe((result: any) => {
        console.log("updatePackarMoverConfigData", result);
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.toastr.success(result.message);
          this.getPackerMoverConfig();
          this.modalService.dismissAll();
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }
  editPackerMoverConfig(editPacMoveConfig) {
    this.openModal(editPacMoveConfig);
    this.packersMoversLitePrice = this.packersMoversLitePrice;
    this.packersMoversLiteStandard = this.packersMoversLiteStandard;
    this.packersMoversLitePremium = this.packersMoversLitePremium;
  }

  // Application Configuration

  mobileNoContactUs: Number;
  emailIdHelp: string;
  splashScreenTime: Number;
  helpLineNo: Number;
  applicationConfigId: any;
  allApplicationConfigData: any;

  userAppVersion: Number;
  driverAppVersion: Number;
  userImg: any;
  driverImg: any;
  userAppUpdates: "";
  driverAppUpdates: "";
  versionDriverImage: any;
  versionUserImage: any;
  driverImage: any;
  userImage: any;
  driverWalletMinimumAmount: Number;
  driverMinimumAmountMessage: "";
  driverAlertDays: Number = 0;
  userAlertDays: Number = 0;
  aiLoadNumberAccess: boolean = false;
  isCommonOTP: boolean = false;
  getApplicationConfig() {
    this.viewAndUpdateConfig
      .getApplcationConfigTable()
      .subscribe((result: any) => {
        console.log("getApplicationCConfig", result);
        if (result.statusCode == 200) {
          this.allApplicationConfigData = result.data;
          this.applicationConfigId = this.allApplicationConfigData._id;
          this.mobileNoContactUs =
            this.allApplicationConfigData.mobileNoContactUs;
          this.emailIdHelp = this.allApplicationConfigData.emailIdHelp;
          this.splashScreenTime =
            this.allApplicationConfigData.splashScreenTime;
          this.helpLineNo = this.allApplicationConfigData.helpLineNo;
          this.userAppUpdates = this.allApplicationConfigData.userAppUpdates;
          this.driverAppUpdates =
            this.allApplicationConfigData.driverAppUpdates;
          this.versionUserImage =
            this.allApplicationConfigData.versionUserImage;
          this.versionDriverImage =
            this.allApplicationConfigData.versionDriverImage;
          this.userImage = this.allApplicationConfigData.versionUserImage;
          this.driverImg = this.allApplicationConfigData.versionDriverImage;
          this.driverAppVersion =
            this.allApplicationConfigData.driverAppVersion;
          this.userAppVersion = this.allApplicationConfigData.userAppVersion;
          this.driverWalletMinimumAmount =
            this.allApplicationConfigData.driverWalletMinimumAmount;
          this.driverMinimumAmountMessage =
            this.allApplicationConfigData.driverMinimumAmountMessage;
          // this.isOnlinePay = this.allApplicationConfigData.isOnlinePay;
          // this.isPayOnDelivery = this.allApplicationConfigData.isPayOnDelivery;
          this.isBillDetails = this.allApplicationConfigData.isBillDetails;
          this.isHelperActive = this.allApplicationConfigData.isHelperActive;
          this.driverAlertDays = this.allApplicationConfigData.driverAlertDays;
          this.userAlertDays = this.allApplicationConfigData.userAlertDays;
          this.aiLoadNumberAccess = this.allApplicationConfigData.aiLoadNumberAccess;
          this.isCommonOTP = this.allApplicationConfigData.isCommonOTP;
          this.viewApplicationConfig = true;
          this.viewPackerMoverConfig = false;
          this.viewPackageConfig = false;
          this.viewQrConfig = false;
          this.viewRange = false;
          this.viewCoupan = false;
        }
      });
  }
  viewImgs: boolean = false;
  viewUserIg: boolean = false;
  viewDrIg: boolean = false;
  viewUserImg() {
    this.viewImgs = true;
    this.viewUserIg = true;
  }
  viewDrImg() {
    this.viewImgs = true;
    this.viewDrIg = true;
  }
  errorMessage: boolean = false;
  checkValidMessage() {
    if (!this.driverMinimumAmountMessage.includes("#")) {
      this.errorMessage = true;
    } else {
      this.errorMessage = false; // No errors
      this.updateApplicationConfig();
    }
  }
  updateApplicationConfig() {
    let data = {
      id: this.applicationConfigId,
      mobileNoContactUs: this.mobileNoContactUs,
      emailIdHelp: this.emailIdHelp,
      splashScreenTime: this.splashScreenTime,
      helpLineNo: this.helpLineNo,
      userAppVersion: this.userAppVersion,
      driverAppVersion: this.driverAppVersion,
      userAppUpdates: this.userAppUpdates,
      driverAppUpdates: this.driverAppUpdates,
      versionDriverImage: this.versionDriverImage,
      versionUserImage: this.versionUserImage,
      driverWalletMinimumAmount: this.driverWalletMinimumAmount,
      driverMinimumAmountMessage: this.driverMinimumAmountMessage,
      // isPayOnDelivery: this.isPayOnDelivery,
      // isOnlinePay: this.isOnlinePay,
      isBillDetails: this.isBillDetails,
      isHelperActive: this.isHelperActive,
      driverAlertDays: this.driverAlertDays,
      userAlertDays: this.userAlertDays,
      aiLoadNumberAccess: this.aiLoadNumberAccess,
      isCommonOTP: this.isCommonOTP,
    };
    console.log("reqData", data);
    this.spinner.show();
    this.viewAndUpdateConfig
      .applicationConfigUpdate(data)
      .subscribe((result: any) => {
        console.log("updateApplicationConfigData", result);
        if (result.statusCode == 200) {
          this.spinner.hide();
          this.toastr.success(result.message);
          this.getApplicationConfig();
          this.modalService.dismissAll();
          this.viewDrIg = false;
          this.userImg = false;
          this.viewImgs = false;
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }
  editApplicationConfig(editAppConfig:any) {
    this.openModal(editAppConfig);
    this.mobileNoContactUs = this.mobileNoContactUs;
    this.emailIdHelp = this.emailIdHelp;
    this.splashScreenTime = this.splashScreenTime;
    this.helpLineNo = this.helpLineNo;
    this.userAppVersion = this.userAppVersion;
    this.driverAppVersion = this.driverAppVersion;
    this.userAppUpdates = this.userAppUpdates;
    this.driverAppUpdates = this.driverAppUpdates;
    this.versionDriverImage = this.versionDriverImage;
    this.versionUserImage = this.versionUserImage;
    this.driverAlertDays = this.driverAlertDays;
    this.userAlertDays = this.userAlertDays;
    this.aiLoadNumberAccess = this.aiLoadNumberAccess;
    this.isCommonOTP = this.isCommonOTP;
  }
  isPayOnDelivery: any;
  isOnlinePay: any;
  isBillDetails: any;
  isHelperActive: any;

  payOnDel(value: any) {
    this.isPayOnDelivery = value;
    // console.log("Pay on Delivery", this.isPayOnDelivery)
  }
  OnlinePay(value: any) {
    this.isOnlinePay = value;
    // console.log("Online Pay", this.isOnlinePay)
  }
  aiLoadNumberAccessChanged(value: any) {
    this.aiLoadNumberAccess = value;
    // console.log("AI Load user number access", this.aiLoadNumberAccess)
  }
  isCommonOTPChanged(value: any) {
    this.isCommonOTP = value;
    // console.log("Common OTP", this.isCommonOTP)
  }
  billdetailsVisible(value: any) {
    this.isBillDetails = value;
    // console.log("Bill Details", this.isBillDetails)
  }
  heplerActive(value: any) {
    this.isHelperActive = value;
    // console.log( "Helper Active",this.isHelperActive)
  }

  // Image Upload
  isValidImage: any;
  isImageUploaded: any;
  isUserValidImage: any;
  isUserImageUploaded: any;
  getUpdatedImage(event: any, type: any) {
    if (type == "UserUpdateImg") {
      if (
        event.target.files[0].type == "image/jpeg" ||
        event.target.files[0].type == "image/jpg" ||
        event.target.files[0].type == "image/png"
      ) {
        this.isUserValidImage = false;
        this.viewAndUpdateConfig
          .addImage(event.target.files[0])
          .subscribe((result: any) => {
            console.log(result);
            if (result.statusCode == 200) {
              this.isUserImageUploaded = true;
              this.versionUserImage = result.photoUrl;
              console.log("userUpdateImg", this.versionUserImage);
            } else {
              this.isUserImageUploaded = false;
              this.isUserImageUploaded = "";
            }
            this.isUserValidImage = false;
          });
      } else {
        this.isUserValidImage = true;
        this.isUserImageUploaded = false;
      }
    } else if (type == "DriverUpdateImg") {
      if (
        event.target.files[0].type == "image/jpeg" ||
        event.target.files[0].type == "image/jpg" ||
        event.target.files[0].type == "image/png"
      ) {
        this.isValidImage = false;
        this.viewAndUpdateConfig
          .addImage(event.target.files[0])
          .subscribe((result: any) => {
            console.log(result);
            if (result.statusCode == 200) {
              this.isImageUploaded = true;
              this.versionDriverImage = result.photoUrl;
              console.log("DriverUpdateImg", this.versionDriverImage);
            } else {
              this.isImageUploaded = false;
              this.isImageUploaded = "";
            }
            this.isValidImage = false;
          });
      } else {
        this.isValidImage = true;
        this.isImageUploaded = false;
      }
    }
  }

  // QR Configuration

  allQrConfig: any;
  mode: any;
  mc: any;
  qrMedium: any;
  tn: any;
  pn: any;
  pa: any;
  createdOn: any;

  qrConfigTable(): void {
    this.spinner.show();
    let data: any = {};
    this.viewAndUpdateConfig.getQrConfigTable(data).subscribe(
      (result: any) => {
        if (result.statusCode === 200) {
          this.spinner.hide();
          console.log("Qr Config", result.data);
          this.allQrConfig = result.data[0];
          this.spinner.hide();
          this.mode = this.allQrConfig.mode;
          this.mc = this.allQrConfig.mc;
          this.qrMedium = this.allQrConfig.qrMedium;
          this.tn = this.allQrConfig.tn;
          this.pn = this.allQrConfig.pn;
          this.pa = this.allQrConfig.pa;
          this.createdOn = this.allQrConfig.createdOn;
          this.viewQrConfig = true;
          this.viewPackerMoverConfig = false;
          this.viewPackageConfig = false;
          this.viewApplicationConfig = false;
          this.viewRange = false;
          this.viewCoupan = false;
        } else {
          this.toastr.error(result.message);
        }
      },
      (error) => {
        console.error("Error:", error);
      }
    );
  }

  openModal(content: any) {
    this.modalService.open(content).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
